import React from 'react';
import './VideoGallery.css';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles({
  firstdiv: {
    position: 'relative',
    flex: '0 0 50%',
    maxWidth: '50%',
    ['@media (min-width: 768px)']: {
      flex: '0 0 25%',
      maxWidth: '25%',
    },
    ['@media (min-width: 576px) and (max-width:767px)']: {
      flex: '0 0 33.33%',
      maxWidth: '33.33%',
    },
  },
});

function VideoItem(props) {
  const classes = useStyles();
  var textoverimage = document.querySelectorAll('.video-desc div');
  for (var i = 0; i < textoverimage; i++) {
    textoverimage.onClick = function () {
      this.classList.toggle('show');
    };
  }
  return (
    <div
      className={
        !props.isservice ? `${classes.firstdiv} video ` : 'videowrapperdiv'
      }
    >
      <img
        src={props.data.thumbnail}
        alt=""
        style={{ height: 'auto', maxWidth: '100%' }}
      />
      <button className="play-btn" onClick={props.onPlay}></button>
      {/* Hover feature on touch-device is not possible, so browser treats click as hover state initialized */}
      <div className="video-desc">
        <p id="vidgallery__paragraph">
          {props.data.description}
          {/* -{props.data.date} */}
        </p>
      </div>
    </div>
  );
}

export default VideoItem;
